import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { IAllDataResponse } from 'app/models/all-data.models';
import { IFilters } from 'app/models/filter.models';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AllDataService {
  constructor(private http: HttpClient) {}

  getAll(filters: IFilters, params: HttpParams): Observable<IAllDataResponse> {
    return this.http
      .post<IAllDataResponse>(
        `${environment.apiUrl}/api/analytics/v2/citations`,
        {
          ...filters,
        },
        {
          params,
        },
      )
      .pipe(
        catchError(() => {
          return of();
        }),
      );
  }

  exportAll(filters: IFilters, params: HttpParams, displayedColumns: string[]) {
    return this.http
      .post(
        `${environment.apiUrl}/api/analytics/citations/export/csv`,
        {
          filters,
          fields: displayedColumns,
        },
        { responseType: 'text', params },
      )
      .pipe(
        catchError(() => {
          return of([]);
        }),
      );
  }
}
